import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { CalendarEventBody, CalendarEventTime, CalendarEventTitle } from "./CalendarEvent";
import "./styles.scss";

export const Availability = ({ position, startTime, endTime, details }) => {
  return (
    <CalendarEventBody className="Availability__body" details={details} position={position}>
      <CalendarEventTitle title="Available" />
      <CalendarEventTime endTime={endTime} startTime={startTime} />
    </CalendarEventBody>
  );
};

Availability.propTypes = {
  position: PropTypes.object,
  startTime: PropTypes.instanceOf(moment),
  endTime: PropTypes.instanceOf(moment),
};
